import React from 'react';
import { connect } from 'react-redux';
import {
  shouldShowActionBar,
  hasError,
  isLoading,
  shouldDisableBulkActions,
} from '../../../selectors';
import IndexActionBar from '../../shared/index/action_bar';
import { clearFilter } from '../../../actions/shared/index/filter';

const EventsActionBar = props => {
  return <IndexActionBar {...props} />;
};

const mapStateToProps = state => ({
  bulkActionDone: state.bulk.done,
  // Action Bar
  visible: shouldShowActionBar(state),
  hasError: hasError(state),
  success: state.bulk.success,
  // Counts
  selectedCount: state.bulk.selected.length,
  totalResults: state.data.totalResults,
  filterIsActive: state.filter.isActive,
  // Loading
  loading: isLoading(state),
  bulkDone: !state.bulk.inProgress && state.bulk.done,
  bulkInProgress: state.bulk.inProgress,
  bulkCount: state.bulk.count,
  bulkName: state.bulk.name,
  // BulkActionsButtons
  disabled: shouldDisableBulkActions(state),
});

const mapDispatchToProps = dispatch => ({
  clearFilter: () => dispatch(clearFilter()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventsActionBar);
